import { MdLocationOn, MdMail } from "react-icons/md";
import { AiFillClockCircle } from "react-icons/ai";

import "./ServiceSliderCard.scss";
import { ServiceSliderCardItem } from "./ServiceSliderCardItem";
import { generateTimeString } from "utils/times/generateTimeString";
import { useIntl } from "react-intl";

export interface ServiceSliderCardProps {
  location: string | JSX.Element;
  email: string;
  title: string;
  address: string;
  workingTime: {
    monday: string[];
    tuesday: string[];
    wednesday: string[];
    thursday: string[];
    friday: string[];
    saturday: string[];
    sunday: string[];
    exceptions: string[];
  };
}

export function ServiceSliderCard({
  location,
  email,
  title,
  address,
  workingTime,
}: ServiceSliderCardProps) {
  const { formatMessage } = useIntl();
  const translatedWorkingHours = generateTimeString(workingTime, formatMessage);

  return (
    <div className="service-slider-card">
      <div className="service-slider-card__header">
        <div className="service-slider-card__header-location">{location}</div>
      </div>
      <div className="service-slider-card__body">
        <ServiceSliderCardItem
          icon={<MdLocationOn />}
          title={title}
          text={address}
          location
        />
        {translatedWorkingHours && (
          <ServiceSliderCardItem
            icon={<AiFillClockCircle />}
            title={formatMessage({
              id: "service.working-hours",
              defaultMessage: "Working Hours",
            })}
            text={
              <>
                {translatedWorkingHours.split(" &nbsp; ").map((time, i) => (
                  <p key={i}>{time}</p>
                ))}
              </>
            }
          />
        )}
        <ServiceSliderCardItem
          icon={<MdMail />}
          title={formatMessage({
            id: "service.email",
            defaultMessage: "Email",
          })}
          text={email}
        />
      </div>
    </div>
  );
}
